<!-- new theme implementation starts -->
<div class="subheader with-padding flgrow">
    <div class="row">
        <div class="col-sm-3">
            <div class="relative flmid">
                <div class="input-group flgrow">
                    <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearchByBrands' | translate }}" [(ngModel)]="pService.searchTerm" autocomplete="off" />
                    <div class="input-group-append">
                        <button type="button" class="btn btn-primary">
                            <em class="fa fa-search"></em>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-auto ml-auto" *ngIf="userRoleRightsDetails.canAdd && isAddBrand">
            <button type="button" (click)="onAdd()" type="reset" class="add-button btn btn-primary" aria-label="Center Align" translate>lblAddBrand</button>
        </div>
    </div>
</div>
<div class="container prel">
    <div class="row">
        <div class="c12">
            <div class="card mb-3">
                <div class="card-header d-flex">
                    <h4 class="card-title" translate>lblBrands</h4>
                </div>
                <div class="table-responsive">


                    <table class="tablest1">
                        <thead>
                            <tr>
                                <th style="width: 55px" scope="col">#</th>
                                <th style="width: 15%" scope="col" sortable="brandCode" (sort)="onSort($event)" translate>lblBrandCode</th>
                                <th scope="col" sortable="brandName" (sort)="onSort($event)" translate>lblBrandName
                                </th>
                                <th style="width: 10%" scope="col" translate>lblImage</th>
                                <th style="width: 10%" scope="col" class="text-center" sortable="isActive" (sort)="onSort($event)" translate>lblActive</th>
                                <th style="width: 120px" scope="col" class="text-center" translate>lblAction</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="brandList?.length>0; else load_else">
                                <tr *ngFor="let brand of brandList; let i=index">
                                    <td>{{ brand.rowNumber }}</td>
                                    <td>
                                        <ngb-highlight [result]="brand.brandCode" [term]="pService.searchTerm"></ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="brand.brandName" [term]="pService.searchTerm"></ngb-highlight>
                                    </td>
                                    <td>
                                        <img af-brand-logo [data-code]="brand.brandCode" data-type="BRAND" class="{{brand.brandCode}}-icon common" style="margin-right: 15px;" [title]="brand.brandCode" class="brandicon" alt="img" />
                                    </td>
                                    <td class="text-center">
                                        <em class="fas" [ngClass]="{'fa-check': brand.isActive, 'fa-close': !brand.isActive}"></em>
                                    </td>
                                    <td class="nowrap text-center">
                                        <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert" (click)="onEdit(brand)" *ngIf="userRoleRightsDetails.canEdit">
                                            <em class="fas fa-pencil-alt fa-lg"></em>
                                        </a>
                                        <span class="ico-div" *ngIf="userRoleRightsDetails.canDelete"></span>
                                        <a class="btn btn-ico" ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert" (click)="deleteBrand(brand.id)" *ngIf="userRoleRightsDetails.canDelete">
                                            <em class="far fa-trash-alt fa-lg"></em>
                                        </a>


                                    </td>
                                </tr>
                            </ng-container>
                            <ng-template #load_else>
                                <tr>
                                    <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer">
                    <div class="d-flex justify-content-between">
                        <div class="d-flex justify-content-between">
                            <ngb-pagination [collectionSize]="pService.total$  | async" [(page)]="pService.page" [pageSize]="pService.pageSize" [maxSize]="3">
                            </ngb-pagination>
                            <select class="custom-select mx-2" style="width: auto" name="pageSize" [(ngModel)]="pService.pageSize">
                <option *ngFor="let item of pService.pageItemsArray" [ngValue]="item.values" translate>{{item.label}}
                </option>
              </select>
                        </div>
                        <div class="d-flex justify-content-between p-2 font17 fontbold" style="margin: auto 0;">
                            <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{pService.total$ | async}}&nbsp;<span class="font17 fontnormal" translate>lblResults</span>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>

</div>
<!-- new theme implementation ends -->